import { useFormContext } from "react-hook-form"
import { useActiveStep } from "../store"
import {
  Bitio,
  CreditCard,
  Form,
  Invoice,
  Scrive,
  SuperOffice,
  Swish,
  Trustly
} from "./methods/methods"

const paymentMethodsMapping = {
  credit_card: CreditCard,
  form: Form,
  swish: Swish,
  trustly: Trustly,
  invoice: Invoice,
  superoffice: SuperOffice,
  scrive: Scrive,
  bitio: Bitio
}

export function PaymentMethods({ orderSessionId }) {
  const { paymentMethods } = useActiveStep()
  const { watch } = useFormContext()
  const currentSelectedPaymentMethod = watch("paymentMethod")

  return paymentMethods.map(({ value: id, label: title }) => {
    const Component = paymentMethodsMapping[id] ?? null

    if (!Component) {
      return null
    }

    return (
      <Component
        key={id}
        id={id}
        title={title}
        selected={id === currentSelectedPaymentMethod}
        orderSessionId={orderSessionId}
      />
    )
  })
}
